import {
  differenceInHours,
  format,
  differenceInDays,
  differenceInMinutes,
} from 'date-fns';

export function formatPublicTs(publicTs: string) {
  const publicTsDate = new Date(publicTs);
  const minutesDiff = differenceInMinutes(new Date(), publicTsDate);
  const hoursDiff = differenceInHours(new Date(), publicTsDate);
  const daysDiff = differenceInDays(new Date(), publicTsDate);

  if (hoursDiff < 1) {
    return minutesDiff + '分前';
  }

  if (hoursDiff <= 24) {
    return hoursDiff + '時間前';
  }

  if (daysDiff <= 7) {
    return daysDiff + '日前';
  }

  return format(publicTsDate, 'yyyy年MM月dd日');
}
